export const work = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: 'Boldare Work',
  url: 'https://www.boldare.com/work/',
  description:
    'Case Studies of our Clients - Portfolio. Digital product creators & consultants.',
  mainEntity: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com/',
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'Business',
        name: 'Olena Brenych',
        email: 'business@boldare.com',
      },
      {
        '@type': 'ContactPoint',
        contactType: 'General',
        email: 'hello@boldare.com',
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Careers',
        email: 'career@boldare.com',
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Public Relations',
        email: 'media@boldare.com',
      },
    ],
  },
};
